import _ from 'lodash';
import tailwindConfig from '../../../tailwind.config';
import { urlFor } from '~/utils/sanity';
import CtaBtn from '~/components/sanity/CtaBtn.vue';
import SanityBlockContent from '~/components/sanity/SanityBlockContent.vue';
import Container from '~/components/sanity/Container.vue';
import BackgroundImage from '~/components/sanity/BackgroundImage.vue';
export default {
  name: 'Hero',
  components: {
    BackgroundImage,
    Container,
    SanityBlockContent,
    CtaBtn
  },
  props: {
    content: Object,
    layout: Object,
    styles: Object,
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      window: {
        height: 0,
        width: 0
      },
      cta: this.content.cta || null,
      heading: this.content.heading || null,
      subheading: this.content.subheading || null,
      noticeType: this.content.noticeType || null,
      notice: this.content.notice || null,
      image: this.content.image || null,
      imageAlign: this.layout.imageAlign,
      imageGap: this.layout.imageGap !== false,
      showMobileImage: this.content.showMobileImage || false,
      mobileImage: this.content.mobileImage || {},
      disclosure: this.content.disclosure || []
    };
  },
  computed: {
    mobile() {
      return this.window.width <= parseFloat(tailwindConfig.theme.screens['sm-md'].max);
    },
    heroImageClassObj() {
      const classes = {
        'order-first': this.layout.desktop === 'textOnRight',
        'sm-md:row-start-1 sm-md:row-end-2': this.layout.mobile === 'textOnBottom'
      };
      if (this.imageAlign === 'bottom' && !this.mobile) {
        classes['lg:pt-16 xl:pt-16'] = true;
      }
      return classes;
    },
    imageUrl() {
      if (!this.image) return;
      return urlFor(this.image).width(447).fit('max').auto('format').url();
    },
    bgImg() {
      if (!this.styles && !this.styles.backgroundImage) return '';
      return this.styles.backgroundImage;
    },
    showBgImg() {
      if (!this.styles) return false;
      const {
        backgroundType,
        backgroundImage
      } = this.styles;
      return backgroundType === 'image' && backgroundImage;
    },
    mobileBgImg() {
      if (!this.styles.mobile && !this.styles.mobile.backgroundImage) return '';
      return this.styles.mobile.backgroundImage;
    },
    showMobileBgImg() {
      if (!this.styles.mobile) return false;
      const {
        backgroundType,
        backgroundImage
      } = this.styles.mobile;
      return backgroundType === 'image' && backgroundImage;
    },
    style() {
      if (!this.styles) return false;
      const {
        color,
        backgroundType,
        backgroundColor
      } = this.styles;
      const style = {
        ...(color && {
          color
        }),
        ...(backgroundType === 'color' && backgroundColor && {
          backgroundColor
        })
      };
      return style;
    },
    mobileStyle() {
      if (!this.styles.mobile) return;
      const {
        color,
        backgroundType,
        backgroundColor
      } = this.styles.mobile;
      const style = {
        ...(color && {
          color
        }),
        ...(backgroundType === 'color' && backgroundColor && {
          backgroundColor
        })
      };
      return style;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  methods: {
    isEmpty(obj) {
      return _.isEmpty(obj);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    debounce(func, wait) {
      let timeout;
      return () => {
        const later = function () {
          timeout = null;
        };
        const callNow = !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func();
      };
    },
    appendDimensions(src, {
      width
    }) {
      return urlFor(src).width(width).fit('max').auto('format').url();
    },
    useAttributes(image) {
      const breakpointWidths = {
        default: 0,
        sm: 640,
        'sm-md': 767,
        lg: 1279,
        xl: 1280
      };
      const srcset = [];
      const sizes = [];
      const attributes = {
        src: null,
        srcset: null,
        sizes: null,
        width: null
        // height: null,
      };
      Object.keys(breakpointWidths).forEach(breakpoint => {
        const width = breakpointWidths[breakpoint];
        const src = this.appendDimensions(image, {
          width
        });
        if (breakpoint === 'default') {
          attributes.src = urlFor(image).width(447).fit('max').auto('format').url();
          attributes.width = '479';
          attributes.height = '479';
        } else {
          srcset.push(`${src} ${width}w`);
          sizes.push(`${breakpointWidths[breakpoint] ? `(min-width: ${breakpointWidths[breakpoint]}px) ` : ''}${width}px`);
        }
      });
      attributes.srcset = srcset.join(', ');
      attributes.sizes = [...sizes].reverse().join(', ');
      return attributes;
    }
  }
};